import { setFilter } from 'modules/locations/store';
import { fetchLocations, fetchLocationsByFilter } from 'modules/locations/store/actions';
import useLocations from 'modules/locations/ui/hooks/use-locations';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { AppDispatch } from 'store/store';
import { useDispatchWithToast } from 'store/use-dispatch-with-toast';

export const useLocationList = () => {
  const dispatch = useDispatch<AppDispatch>();
  const dispatchWithToast = useDispatchWithToast();
  const { isLoading, isLoaded, locations, tournamentId, locationLoadedLimit, allDataLoaded, filter } = useLocations();

  const loadNextPage = useCallback(() => {
    if (isLoading) return;
    if (locations.length === 0) return;
    if (!tournamentId) return;
    if (allDataLoaded) return;

    dispatchWithToast(
      fetchLocations({
        tournamentId,
        limit: locationLoadedLimit,
        offset: locations.length,
      }),
      { error: 'Не удалось загрузить локации' },
    );
  }, [isLoading, locations.length, tournamentId, allDataLoaded, dispatchWithToast, locationLoadedLimit]);

  const onChangeFilter = useCallback(
    (value: string) => {
      if (!tournamentId) return;

      if (filter.text === value) return;
      dispatch(setFilter({ text: value }));

      if (value) {
        dispatchWithToast(fetchLocationsByFilter({ nameFilter: value, tournamentId, limit: locationLoadedLimit }), {
          error: 'Не удалось выполнить поиск локаций',
        });
      }
    },
    [dispatch, dispatchWithToast, filter.text, locationLoadedLimit, tournamentId],
  );

  return {
    isLoading: isLoading || filter.isLoading,
    isLoaded,
    locations,
    loadNextPage,
    onChangeFilter,
    filteredLocations: Boolean(filter.text) ? filter.locations : null,
  };
};
